<p-dialog 
  [(visible)]="visible" 
  [modal]="true" 
  [closable]="true" 
  [breakpoints]="{ '1199px': '80vw', '700px': '90vw' }" 
  [style]="{ width: '65vw', height: '80vh' }" 
  (onHide)="closeDialog()">
  <p-stepper [value]="activeIndex()">
    <p-step-item [value]="1">
        <p-step>Préambule</p-step>
        <p-step-panel>
            <ng-template #content let-activateCallback="activateCallback">
                <div class="flex flex-row h-80">
                    <div class="border-2 border-dashed border-surface-200 dark:border-surface-700 rounded bg-surface-50 dark:bg-surface-950 flex flex-col w-full gap-2 p-8 font-medium">
                        <p class="my-2">
                            Afin de retrouver votre dossier dans notre base de données, nous allons vous proposer deux méthodes : par l'adresse email que vous avez communiqué a notre intervenant-e, ou par le numéro de téléphone.<br>
                            Selon la méthode choisi, nous aurons besoin d'une vérification pour s'assurer qu'il s'agit bien de votre numéro de téléphone.
                            <br><br>

                            <strong>Veuillez noter que si vous nous avez jamais rencontré, votre dossier sera introuvable, il est nécessaire de prendre un premier rendez-vous via cette application.</strong>
                        </p>
                    </div>
                </div>
                <div class="flex py-6 gap-2">
                    <p-button  label="Suivant" (onClick)="goToStep(2);activateCallback(2)" severity="contrast"/>
                </div>
            </ng-template>
        </p-step-panel>
    </p-step-item>

    <p-step-item [value]="2">
        <p-step>Methode de recherche</p-step>
        <p-step-panel>
            <ng-template #content let-activateCallback="activateCallback">
                <div class="flex flex-col h-70 overflow-auto">
                    <p-table stripedRows [value]="verificationMethods" class="w-full overflow-auto"  [paginator]="false" [rows]="5" responsiveLayout="scroll">
                        <ng-template #body let-method (onClick)="chooseTypeVerification(method.key);goToStep(3);activateCallback(3)"> 
                            <tr>
                                <td style="width: 25%; min-width: 7rem;"> <b>{{method.libelle}} </b></td>
                                <td style="width: 55%; min-width: 8rem;"> {{method.description}}</td>
                                <td style="width: 15%;">
                                    <p-button pRipple (onClick)="chooseTypeVerification(method.key);goToStep(3);activateCallback(3)" type="button" label="Valider" class="p-button p-component p-button-text p-button-outlined"></p-button>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
                <div class="flex py-6 gap-2">
                    <p-button label="Précédent" severity="secondary" (onClick)="goToStep(1);activateCallback(1)" />
                </div>
            </ng-template>
        </p-step-panel>
    </p-step-item>

    <p-step-item [value]="3">
        <p-step>Mes coordonnées</p-step>
        <p-step-panel>
            <ng-template #content let-activateCallback="activateCallback">
                <div class="flex flex-col h-70 justify-center items-center gap-4">
                    <div class="flex flex-col gap-2">
                        <p *ngIf="verificationMethod == 'SMS'">Merci de saisir le numéro de téléphone que vous avez renseigné lors de votre dernier rendez-vous avec notre intervenant. Nous vous enverrons alors un code par SMS.</p>
                        <p *ngIf="verificationMethod == 'EMAIL'">Merci de saisir l'email que vous avez renseigné lors de votre dernier rendez-vous avec notre intervenant. Nous vous enverrons alors un code par mail.</p>
                        <label for="phoneemail">{{ verificationMethod == 'SMS' ? 'N° de téléphone' : 'Adresse e-mail' }}</label>
                        <input 
                            pInputText 
                            id="phoneemail" 
                            aria-describedby="phone-help" 
                            [(ngModel)]="verificationValue" 
                            (ngModelChange)="validateInput()" 
                        />
                        <small *ngIf="verificationMethod == 'SMS'" id="phone-help">Merci de saisir votre numéro de téléphone au format 0606060606</small>
                        <small *ngIf="verificationMethod == 'SMS'" id="phone-help">Merci de ne pas mettre de points, virgule, slash ou annotations</small>
                        <small *ngIf="errorMessage" class="text-red-500">{{ errorMessage }}</small>
                    </div>

                </div>
                <div class="flex py-6 gap-2">
                    <p-button label="Précédent" severity="secondary" (onClick)="goToStep(2);activateCallback(2)" />
                    <p-button label="Suivant" [disabled]="!isInputValid" (onClick)="askVerificationCode();" severity="contrast"/>
                </div>
            </ng-template>
        </p-step-panel>
    </p-step-item>

    <p-step-item [value]="4">
        <p-step>Validation de mes coordonnées</p-step>
        <p-step-panel>
            <ng-template #content let-activateCallback="activateCallback">
                <p-message *ngIf="verificationMethod == 'SMS'" severity="success">Nous vous avons envoyé votre code par sms au numéro indiqué, merci de le saisir ci-dessous puis cliquer sur suivant.</p-message>
                <p-message *ngIf="verificationMethod == 'EMAIL'" severity="success">Nous vous avons envoyé votre code à l'adresse email indiquée, merci de le saisir ci-dessous puis cliquer sur suivant.</p-message>
                
                <div class="text-center">
                    <p-inputotp 
                        class="justify-center" 
                        [(ngModel)]="verificationCodeReceived" 
                        [length]="8" 
                        (ngModelChange)="validatorVerificationCode()" 
                        (paste)="handlePaste($event)">
                        <ng-template #input let-token let-events="events" let-index="index">
                            <input 
                                pInputText 
                                type="text" 
                                [maxLength]="1" 
                                (input)="events.input($event)" 
                                (keydown)="events.keydown($event)" 
                                [attr.value]="token" 
                                class="custom-otp-input" />
                            <div *ngIf="index === 4" class="px-4">
                                <i class="pi pi-minus"></i>
                            </div>
                        </ng-template>
                    </p-inputotp>
                </div>
                <div class="flex justify-center mt-8 self-stretch">
                    <p-button 
                        [disabled]="resendTimer > 0" 
                        label="{{ resendTimer > 0 ? 'Renvoyer le code (' + resendTimer + 's)' : 'Renvoyer le code' }}" 
                        class="p-0" 
                        variant="outlined" 
                        severity="secondary" 
                        (onClick)="startResendTimer();askVerificationCode()">
                    </p-button>
                </div>
                
                <div class="flex py-6 gap-2">
                    <p-button label="Précédent" severity="secondary" (onClick)="goToStep(3);activateCallback(3)" />
                    <p-button label="Suivant" [disabled]="!isVerificationCodeValid" (onClick)="validateVerificationCode()" severity="contrast"/>
                </div>
            </ng-template>
        </p-step-panel>
    </p-step-item>

    <p-step-item [value]="5">
        <p-step>Validation</p-step>
        <p-step-panel>
            <ng-template #content let-activateCallback="activateCallback">
                <div class="flex flex-col max-h-80 overflow-auto">
                    <p-message *ngIf="listDossiers.length > 1" severity="warn">Nous avons trouvé plusieurs dossiers correspondants a vos coordonnées, en cas de doute, merci de passer par notre secrétariat ou intervenant.</p-message>
                    <p-message *ngIf="listDossiers.length === 0" severity="warn">Nous n'avons trouvé aucun dossier correspondant a vos coordonnées. Si vous avez déja utilisé nos services, merci de vous rapprocher de notre secrétariat ou notre intervenant.</p-message>

                    <div class="p-3">
                        <div *ngFor="let dossier of listDossiers" class="bg-surface-50 cursor-pointer z-index border-round border-l-4 rounded-sm mb-2">
                            <div class="p-3">
                                <div class="text-900 font-semibold text-xl mb-3">{{dossier.nom}} {{dossier.prenom}}</div>
                                <p class="text-700 text-lg mt-0 mb-5">{{dossier.description}}</p>
                    
                                <div class="flex flex-wrap gap-2 align-items-center justify-between">
                                    <span class="flex align-items-center text-900">
                                        <div class="mr-4">
                                            <i class="pi pi-at mr-2"></i>
                                            <span class="font-semibold">{{dossier.email}}</span>
                                        </div>
                                        <div>
                                            <i class="pi pi-phone mr-2"></i>
                                            <span class="font-semibold mr-1">{{dossier.telephone}}</span>
                                        </div>
                                    </span>
                                    <span class="flex align-items-center text-900">                                    
                                        <p-button pRipple (onClick)="createLink(dossier)" type="button" label="Valider" class="p-button p-component p-button-text p-button-outlined"></p-button>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex py-6 gap-2">
                    <p-button label="Précédent" severity="secondary" (onClick)="goToStep(4);activateCallback(4)" />
                </div>
            </ng-template>
        </p-step-panel>
    </p-step-item>

    <p-step-item [value]="6">
        <p-step>Finalisation</p-step>
        <p-step-panel>
            <ng-template #content let-activateCallback="activateCallback">
                <div class="flex flex-col max-h-80 overflow-auto">
                    <p-message severity="success">Nous avons réussi a relier votre plateforme a votre profil {{app}}.</p-message>

                    <div class="p-3">
                        <p class="mb-2">Cependant, afin de vous faire bénéficier des nouvelles fonctionnalités, nous vous proposer de recharger l'application en cliquant sur le bouton <b>"Terminer"</b> ci-dessous.</p>
                        <p>Il est possible que les nouvelles fonctionnalités n'apparaissent pas de suite, si tel est le cas, <u>elles arriveront alors sous peu de temps</u></p>
                    </div>
                </div>
                <div class="flex py-6 gap-2">
                    <p-button label="Terminer" severity="secondary" (onClick)="finalize()" />
                </div>
            </ng-template>
        </p-step-panel>
    </p-step-item>
  </p-stepper>
</p-dialog>
